import React from "react";
import { cn } from "../../../utils/tw";

interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  name: string;
}

export const Avatar: React.FC<AvatarProps> = ({ name, className, src, ...props }) => {
  const initials = name
    .split(" ")
    .map(n => n[0])
    .join("")
    .toUpperCase();
  return src ? (
    <img
      src={src}
      alt={name}
      className={cn("rounded-full w-8 h-8 object-cover", className)}
      {...props}
    />
  ) : (
    <div
      className={cn(
        "rounded-full w-8 h-8 bg-secondary text-primary flex items-center justify-center text-sm font-semibold",
        className
      )}
      {...props as any}
    >
      {initials}
    </div>
  );
};

export default Avatar;
